import { useTranslation } from 'react-i18next';

import { useDiscoveryLocation } from '../../lib/geo/discovery-location';
import { Icon } from '../icons/icon';
import { CityPicker } from './city-picker';

/**
 * «Perto de: Lisboa» do cabeçalho (canvas `header_consumer`) + o seletor que ele abre.
 *
 * A origem fica visível em todas as telas da descoberta: o consumidor sabe sempre de onde a
 * distância é medida — e, sem origem, vê o convite a escolher em vez de uma cidade inventada.
 */
export function LocationControl() {
  const { t } = useTranslation();
  const { location, status, chooseCity, requestDevice, pickerOpen, openPicker, closePicker } = useDiscoveryLocation();

  const place = location?.city?.name ?? (location ? t('discovery.location.device') : null);

  return (
    <>
      <button
        className="hit pc-loc"
        type="button"
        aria-haspopup="dialog"
        onClick={openPicker}
        data-testid="location-control"
      >
        <Icon name="pin" size={16} />
        <span>
          {place ? (
            <>
              {t('discovery.location.near')} <strong>{place}</strong>
            </>
          ) : (
            <strong>{status === 'loading' ? t('discovery.location.loading') : t('discovery.location.choose')}</strong>
          )}
        </span>
        <Icon name="chevDown" size={16} />
      </button>
      <CityPicker
        open={pickerOpen}
        onClose={closePicker}
        selectedCityId={location?.source === 'city' ? location.city?.id ?? null : null}
        status={status}
        onChooseCity={chooseCity}
        onUseDevice={requestDevice}
      />
    </>
  );
}
